<tpm-card
  no-padding
  rounded-8
  class="news-carousel-item"
  [class.news-carousel-item__asset-container--mobile]="isMobile"
  variant="elevation-basic-10"
>
  <div class="news-carousel-item-container">
    <div
      *ngIf="!isMobile"
      class="news-carousel-item__asset-container"
      [class.news-carousel-item__asset-container--divider]="!!$any(props).icon"
    >
      <tpm-tag
        *ngIf="showBadge"
        class="badge"
        textColor="var(--ene-color-white)"
        backgroundColor="var(--ene-color-primary-600)"
      >
        News
      </tpm-tag>
      <img *ngIf="!!$any(props).teaserImage" class="image" [ngSrc]="$any(props).teaserImage" fill />
      <tpm-icon *ngIf="!!$any(props).icon" class="icon" [icon]="$any(props).icon"></tpm-icon>
    </div>
    <div class="news-carousel-item__body">
      <p class="date">{{ props.date | date : "dd.MM.yyyy" }}</p>
      <p class="headline last-line-1">{{ props.headline }}</p>
    </div>
  </div>
</tpm-card>
